<i18n>
{
  "en": {
    "optimizerTitle": "Optimizer",
    "priceProfitabilityError": "Error loading prices profitability. Please, try it later",
    "outOfMenuError": "Error loading out of menu products. Please, try again later",
    "generatingOutOfMenu": "Generating products out of menu",
    "priceChangeError": "Error loading list of price changes. Please, try again later.",
    "priceChangeActiveWaitMessage": "Generating list of price change of products.",
    "outOfMenuTitle": "Out of Menu"
  },
  "es": {
    "optimizerTitle": "Optimizador",
    "priceProfitabilityError": "Error cargando previsión de rentabilidad en precios. Inténtelo de nuevo más tarde.",
    "outOfMenuError": "Error cargando productos fuera de menú. Inténtelo de nuevo más tarde",
    "priceChangeError": "Error cargando la lista de cambio de precios. Inténtelo de nuevo más tarde",
    "generatingOutOfMenu": "Generando productos fuera de menú",
    "priceChangeActiveWaitMessage": "Generando el archivo de cambio de precios de productos.",
    "outOfMenuTitle": "Fuera de Carta"
  }
}
</i18n>

<template>
  <v-container fluid grid-list-sm>
    <optimizer-pro-panel @priceManager="onPriceManager" @groupForecaster="onForecast"
                         @menuManager="onMenuManager"/>
    <menu-preview-modal :visible="previewModalVisible" @cancel="onMenuPreviewCancel"
                        @confirm="onMenuPreviewConfirm"/>
  </v-container>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import DynameatDropdown from '@dynameat/components/DynameatDropdown';
import PeriodPicker from '@optimizer/components/PeriodPicker';
import MenuPreviewModal from '@menuPreview/components/MenuPreviewModal.vue';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import OptimizerProPanel from '../components/OptimizerProPanel.vue';

@Component
@Components({
  PeriodPicker, OptimizerProPanel, DynameatDropdown, MenuPreviewModal, DynameatConfirmationModal
})
@MapActions(['addNotification'])
@MapGetters(['predictionPeriodList', 'nextPeriod'])
export default class OptimizerProView extends Vue {
  previewModalVisible = false;

  selectedPeriod = null

  onForecast() {
    this.$router.push({
      name: 'group-forecaster-pro',
      params: { periodGuid: this.nextPeriod?.guid || this.predictionPeriodList[0].guid }
    });
  }

  onPriceManager() {
    this.$router.push({ name: 'price-manager' });
  }

  onMenuManager() {
    this.$router.push({ name: 'menu-manager' });
  }

  onMenuPreviewCancel() {
    this.previewModalVisible = false;
  }

  onMenuPreviewConfirm() {
    this.previewModalVisible = false;
  }
}
</script>
